<template>
  <div :style="{ width: width, height: height }" class="d-flex">
    <v-tooltip v-for="(section, index) in sections" :key="index" close-delay="50" open-delay="50" content-class="tooltip" bottom>
      <template v-slot:activator="{ on, attrs }">
        <div :style="{ width: section.width, backgroundColor: section.color }" v-bind="attrs" v-on="on"></div>
      </template>
      <span>{{ section.title }}: {{ section.value }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { comma } from '@/utils/formatter';

export default {
  props: {
    colors: {
      type: Array,
      default: () => {
        return ['#FF3333', '#00FFFF', '#6688FF', '#3333FF', '#DD33DD', '#FF0000', '#FFCC00'];
      },
    },
    titles: {
      type: Array,
      default: function() {
        return [this.$t('cmpnt.title.disp.wait'), this.$t('cmpnt.title.rollin'), this.$t('cmpnt.title.loadgen'), this.$t('cmpnt.title.proc'), this.$t('cmpnt.title.db'), this.$t('cmpnt.title.enq.lock'), this.$t('cmpnt.title.rollwait')];
      },
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '14px',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    sections() {
      const sum = this.items.reduce((acc, value) => acc + value, 0);
      const sections = [];

      this.items.forEach((value, index) => {
        if (value > 0) {
          let width = parseFloat((value / sum) * 100);
          width = width < 1 ? 1 : width;
          sections.push({
            value: comma(value),
            width: `${width.toFixed(1)}%`,
            color: this.colors[index],
            title: this.titles[index],
          });
        }
      });
      return sections;
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltip {
  font-size: 11px;
  padding: 1px 5px 1px 5px;
  opacity: 1 !important;
}
.d-flex > div {
  margin-right: 3px;
}
</style>
